import React from 'react';
import {
  ProgramBox,
  ProgramContent,
  ProgramFlex,
  ProgramStack,
  ProgramTitle,
  ProgramText,
  ProgramImage,
  useProgram,
} from 'planby';

export const Program = ({ isVerticalMode, program, startDate, endDate, isVisible , ...rest }) => {
  const {
    styles,
    formatTime,
    set12HoursTimeFormat,
    isLive,
    isMinWidth,
  } = useProgram({
    isVerticalMode,
    program,
    ...rest,
  });

  const { data } = program;
  const { image, title, since, till, plannedQuantity, producedQuantity, description } = data;

  const sinceTime = formatTime(since, set12HoursTimeFormat()).toLowerCase();
  const tillTime = formatTime(till, set12HoursTimeFormat()).toLowerCase();

  const producedPercentage = ((producedQuantity / plannedQuantity) * 100).toFixed(2);

  const hideLeftBorder = new Date(since) < new Date(startDate);
  const hideRightBorder = new Date(till) > new Date(endDate);

  const additionalClasses = [
    hideLeftBorder ? 'starts-before' : '',
    hideRightBorder ? 'ends-after' : '',
    'planby-program-content',
  ]
    .filter(Boolean)
    .join(' ');

  // console.log(since, sinceTime, till, tillTime);
  return (
    <ProgramBox
      hidden={!isVisible} 
      width={styles.width}
      style={styles.position}
      className="planby-program"
      onDoubleClick={rest.onDoubleClick}
    >
      <ProgramContent
        isVerticalMode={isVerticalMode}
        width={styles.width}
        isLive={isLive}
        className={additionalClasses}
      >
        <div
          style={{
            position: 'absolute',
            backgroundColor: '#fca31180',
            width: `${producedPercentage}%`,
            height: '100%',
            left: 0,
            top: 0,
            zIndex: -1,
          }}
        ></div>
        <ProgramFlex isVerticalMode={isVerticalMode}>
          {/* {isLive && isMinWidth && (
            <ProgramImage
              isVerticalMode={isVerticalMode}
              src={image}
              alt="Preview"
            />
          )} */}
          <ProgramStack>
            <ProgramTitle className="planby-program-title">
              <span title={`${title} - ${description}`}>
                {title} - {description}
              </span>
            </ProgramTitle>
            <ProgramText className="planby-program-text">
              <span title={`${sinceTime} - ${tillTime}`}>
                {sinceTime} - {tillTime}
              </span>
            </ProgramText>
          </ProgramStack>
        </ProgramFlex>
      </ProgramContent>
    </ProgramBox>
  );
};